var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry-pillar"},[_c('title-one',{attrs:{"title":_vm.title || '',"ps-txt":_vm.psTxt}}),_c('div',{staticClass:"rank-two left"},_vm._l((_vm.list || []),function(item,index){return _c('progress-item',{key:index,attrs:{"progress":_vm._f("changeProgress")(item,_vm.total || 0)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }